module.exports = __webpack_public_path__ + "fonts/WorkSans-Black.7077ff4.woff2";